import React, { ReactNode } from "react";

export interface AuthProviderProps {
  children: ReactNode;
}

// No auth
export function AuthProvider({ children }: AuthProviderProps) {
  return <>{children}</>;
}
